<template>
  <v-layout justify-center>
    <v-flex>
      <router-view />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "CardPages"
};
</script>
